module.exports = "/fonts/vendor/slick-carousel/slick/slick.woff?295183786cd8a138986521d9f388a286";